document.addEventListener("DOMContentLoaded", function () {
  $(function () {
    $(".materials-tabs .tabs-container").slick({
      infinite: true,
      draggable: true,
      slidesToShow: 6,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 3000,
      nextArrow: `<button type="button" class="slick-next" role="button" aria-label="Next">
    <svg
      role="img"
      width="7"
      height="13"
    aria-labelledby="icon-left-arrow-title"
      viewBox="0 0 7 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title id="icon-right-arrow-title">Next</title>
      <path d="M1 1L6 6.5L1 12" stroke="currentColor" fill="none"/>
    </svg>
  </button>`,
      prevArrow: `<button type="button" class="slick-prev" role="button" aria-label="Previous"><svg
    role="img"
    aria-label="left-arrow"
    aria-labelledby="icon-left-arrow-title"
    width="7"
    height="13"
    viewBox="0 0 7 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id="icon-left-arrow-title">Prev</title>
    <path d="M6 1L1 6.5L6 12" stroke="currentColor" fill="none"/>
  </svg></button>`,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 5,
          },
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 591,
          settings: {
            slidesToShow: 3.5,
            infinite: false,
            swipeToSlide: true,
          },
        },
      ],
    });

    $(document).on(`click`, `.materials-tabs .tabs-item`, function (e) {
      e.stopPropagation();
      e.preventDefault();
      let clickedId = $(this).attr(`data-tabid`);
      if ($(`#${clickedId}`).length) {
        $("html, body").animate(
          {
            scrollTop: $(`#${clickedId}`).offset().top - 150 + "px",
          },
          500
        );
        return false;
      }
    });
  });
});
